module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [(_vm.searchModalOpen) ? _c('searchModal', {
    attrs: {
      "closeSearchModal": _vm.closeSearchModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-top-city-container",
    attrs: {
      "id": "sticky-search-bar"
    }
  }, [(_vm.$store.state.common.isModeSwipe != true) ? _c('div', {
    staticClass: "toolbar-content-container pos-rel"
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('a', {
    staticClass: "go-back-icon-and-fullscreen-mobile",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.filterViewType))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "list-view-text",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('searchContainer')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-section-3"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_c('div', {
    staticClass: "pill-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "0.5px solid #b6b6b6",
      "width": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pill pointer"
  }, [(!_vm.isLoggedIn && this.screenW < 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && this.screenW > 600) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("perm_identity")]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('img', {
    staticStyle: {
      "height": "1.75rem",
      "width": "1.75rem",
      "border-radius": "100%"
    },
    attrs: {
      "src": this.$store.state.auth.user.photoURL
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pills-description"
  }, [_c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Travel list")]), _vm._v(" "), _c('label', {
    staticClass: "description-item pointer",
    on: {
      "click": function($event) {
        _vm.isLoggedIn
          ?
          _vm.$router.push({
            path: '/profile',
            query: {
              profile_Id: _vm.user.uid,
              selected_tab: 'checkins',
            },
          }) :
          _vm.$router.push("/login")
      }
    }
  }, [_vm._v("Profile")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.showScrollArrow && !_vm.$store.state.common.isModeSwipe) ? _c('div', {
    staticClass: "arrow-container"
  }, [_c('div', {
    staticClass: "arrow-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.isModeSwipe && _vm.filteredImagesArr.length > 0) ? _c('div', [(!_vm.showOnboardings) ? _c('div', [_c('div', {
    staticClass: "footer-container-main mobile-expand-icon",
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "id": "fade-foot"
    }
  }, [_c('div', {
    staticClass: "footer-container-new blurred-bg"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "like-share-fullscreen-container"
  }, [_c('div', {
    staticClass: "fullscreen-box",
    on: {
      "click": function($event) {
        _vm.isSwipeZoom = !_vm.isSwipeZoom
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1.8em"
    },
    style: (_vm.isSwipeZoom ? 'color: rgb(254, 189, 53)' : '')
  }, [_vm._v(_vm._s(_vm.isSwipeZoom ? "zoom_out_map" : "fullscreen_exit"))])])]), _vm._v(" "), _c('div', {
    staticClass: "swipe-up-arrow"
  })])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.common.isModeSwipe && _vm.filteredImagesArr.length > 0) ? _c('div', [(!_vm.showOnboardings) ? _c('div', [_c('div', {
    staticClass: "footer-container-main mobile-side-icons",
    staticStyle: {
      "z-index": "100"
    },
    attrs: {
      "id": "fade-foot"
    }
  }, [_c('div', {
    staticClass: "footer-container-new blurred-bg"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "swipe-up-arrow"
  }), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "material-icons flip-reply-icon mb-3 ml-1",
    on: {
      "click": function($event) {
        return _vm.share(
          _vm.filteredImagesArr[_vm.swipeIndex].id,
          _vm.filteredImagesArr[_vm.swipeIndex].caption === '' ?
          'n' :
          _vm.filteredImagesArr[_vm.swipeIndex].caption
        )
      }
    }
  }, [_vm._v("reply")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "margin-bottom": "23px"
    },
    on: {
      "click": function($event) {
        return _vm.changeCnt()
      }
    }
  }, [_c('div', {
    style: ({
      visibility: ("" + (_vm.filteredImagesArr[_vm.swipeIndex].likes === 0
                        ? 'hidden'
                        : 'visible')),
    })
  }, [_vm._v("\n                  " + _vm._s(_vm.filteredImagesArr[_vm.swipeIndex].likes) + "\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons mobile_like",
    style: (_vm.filteredImagesArr[_vm.swipeIndex].isLiked ?
      'color:#ff0000' :
      'color:#ffffff')
  }, [_vm._v(_vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isLiked ?
    "favorite" :
    "favorite_outline"))])]), _vm._v(" "), _c('div', {
    staticClass: "want-to-go-button",
    on: {
      "click": function($event) {
        return _vm.changeCntCheckin()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
    "" :
    ("" + (_vm.filteredImagesArr[_vm.swipeIndex].checkins !== 0
                          ? _vm.filteredImagesArr[_vm.swipeIndex].checkins
                          : ""))) + "\n                "), _c('i', {
    staticClass: "material-icons",
    style: (!_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
      'color: white; backgroundColor:#bd10e0;' :
      '')
  }, [_vm._v(_vm._s(_vm.filteredImagesArr[_vm.swipeIndex].isCheckedin ?
    "check" :
    "add"))])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-container-main pos-fixed",
    class: ("blur-it-" + (_vm.$store.state.common.swichModesBG)),
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [(_vm.swipeIndex < 2 && _vm.$store.state.common.isModeSwipe) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideOnBoardingOn.indexOf(_vm.swipeIndex) === -1),
      expression: "hideOnBoardingOn.indexOf(swipeIndex) === -1"
    }],
    staticStyle: {
      "position": "fixed",
      "z-index": "10000000",
      "width": "100%",
      "top": "48%"
    },
    attrs: {
      "id": "arrow_down"
    }
  }, [(_vm._isFirstVisit) ? _c('div', [_c('div', {
    staticClass: "swipe-arrow-text",
    domProps: {
      "innerHTML": _vm._s(_vm.swipeArrowText)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa style-icon bounce",
    class: _vm.swipeArrowIcon
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullscreen-container pos-rel"
  }, [(_vm.$store.state.common.isModeSwipe) ? _c('div', {
    staticClass: "pos-rel swipe-container"
  }, [_c('v-layout', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function() {},
        right: function() {},
        up: function() {
          _vm.increment();
        },
        down: function() {
          _vm.decrement();
        },
      }),
      expression: "{\n              left: function () {},\n              right: function () {},\n              up: function () {\n                increment();\n              },\n              down: function () {\n                decrement();\n              },\n            }"
    }],
    staticClass: "grey lighten-2",
    staticStyle: {
      "overflow-y": "hidden",
      "height": "100vh"
    },
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": "",
      "id": "layout-swipe"
    },
    on: {
      "touchend": function($event) {
        return _vm.easeOut(1)
      }
    }
  }, [_c('div', {
    style: (_vm.isSwipeZoom ?
      'display: flex; background: black' :
      {
        width: (_vm.screenW + "px"),
        height: (_vm.screenH + "px")
      })
  }, [(
    _vm.getSwipeCount() == 1 ||
    (_vm.getSwipeCount() == 3 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('img', {
    staticClass: "left-right-hand-swipe",
    attrs: {
      "src": require("../../static/img/left-right-hand-swipe-white.png")
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 1 ||
    (_vm.getSwipeCount() == 3 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('span', {
    staticClass: "gesture-text-swipe-sides"
  }, [_vm._v("\n                Swipe left and right\n                "), _c('br'), _vm._v("to see the complete image\n              ")]) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 0 ||
    (_vm.getSwipeCount() == 2 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('img', {
    staticClass: "long-up-arrow",
    attrs: {
      "src": require("../../static/img/long-up-arrow-white.svg")
    },
    on: {
      "click": _vm.increment
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.getSwipeCount() == 0 ||
    (_vm.getSwipeCount() == 2 && _vm.$store.state.common.isModeSwipe)
  ) ? _c('span', {
    staticClass: "gesture-text-swipe-up",
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("Swipe up for the next view")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "city-spotType",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/filter',
          query: _vm.$route.query
        })
      }
    }
  }, [_c('label', {
    staticClass: "loc-name"
  }, [_vm._v(_vm._s(_vm.getCity(_vm.filteredImagesArr[_vm.swipeIndex])) + " |")]), _vm._v(" "), _c('label', {
    staticClass: "spot-name",
    style: (_vm.getSpotType(_vm.filteredImagesArr[_vm.swipeIndex]) == 'Spot' ?
      'opacity: 0.7' :
      'opacity: 1')
  }, [_vm._v(_vm._s(_vm.getSpotType(_vm.filteredImagesArr[_vm.swipeIndex])))])]), _vm._v(" "), (_vm.getSwipeCount() == 4 && _vm.$store.state.common.isModeSwipe) ? _c('span', {
    staticClass: "tap-for-details",
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("Tap anywhere for details")]) : _vm._e(), _vm._v(" "), (_vm.filteredImagesArr.length != 0) ? _c('img', {
    style: (_vm.isSwipeZoom ?
      ("width: " + _vm.screenW + "px; object-fit: contain") :
      ("height:" + _vm.screenH + "px")),
    attrs: {
      "src": _vm.fullscreenImage(
        _vm.filteredImagesArr[_vm.swipeIndex].id,
        _vm.filteredImagesArr[_vm.swipeIndex]
      ),
      "id": ("element-" + _vm.swipeIndex),
      "alt": "image"
    },
    on: {
      "click": function($event) {
        return _vm.imageClick($event, _vm.filteredImagesArr[_vm.swipeIndex])
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "opacity": "0.9",
      "z-index": "3",
      "visibility": "hidden",
      "left": "0"
    },
    attrs: {
      "id": ("swipe-ele-black-inc-" + _vm.swipeIndex)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "z-index": "2",
      "visibility": "hidden",
      "left": "0"
    },
    attrs: {
      "id": ("swipe-ele-image-inc-" + _vm.swipeIndex)
    }
  }, [_c('p', {
    staticClass: "current-page"
  }, [_vm._v(_vm._s(_vm.currentPage))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "bottom": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "opacity": "0.4",
      "z-index": "3",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("swipe-ele-black-" + _vm.swipeIndex)
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0",
      "bottom": "-100vh",
      "position": "fixed",
      "height": "100vh",
      "width": "100vw",
      "background-color": "#313131",
      "z-index": "2",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("swipe-ele-image-" + _vm.swipeIndex)
    }
  }, [_c('p', {
    staticClass: "current-page"
  }, [_vm._v(_vm._s(_vm.currentPage))])])])])], 1) : _c('div', {
    staticClass: "img-cont pos-rel touch",
    attrs: {
      "id": "layout-scroll"
    },
    on: {
      "scroll": _vm.getScrollPos
    }
  }, [(_vm.filteredImagesArr.length != 0) ? _c('div', {
    staticClass: "list-view-images-container"
  }, _vm._l((_vm.filteredImagesArr), function(image, imageIndex) {
    return _c('div', {
      key: imageIndex,
      ref: ("scroll" + imageIndex),
      refInFor: true,
      staticClass: "relative-img touch",
      attrs: {
        "id": ("scroll" + imageIndex)
      },
      on: {
        "mouseover": function($event) {
          return _vm.updateSwipeIndex(imageIndex)
        },
        "touchstart": function($event) {
          return _vm.updateSwipeIndex(imageIndex)
        }
      }
    }, [_c('div', {
      staticClass: "list-view-image-container"
    }, [_c('div', {
      staticClass: "card-top hidden-md-and-up"
    }, [_c('label', {
      staticClass: "image-caption"
    }, [_vm._v(_vm._s(image.caption) + " in ")]), _vm._v(" "), _c('div', {
      staticClass: "location-details"
    }, [_c('label', {
      staticClass: "spot-name pointer",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)))]), _vm._v(" "), _c('label', {
      staticClass: "loc-name pointer"
    }, [_vm._v(_vm._s(_vm.getCity(image)) + ",\n                      " + _vm._s(image.aboutLoc.country))])])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "position": "relative",
        "z-index": "11",
        "height": "100%",
        "overflow": "hidden"
      }
    }, [_c('a', {
      staticStyle: {
        "width": "75%",
        "border-radius": "12px",
        "overflow": "hidden"
      },
      attrs: {
        "href": _vm.currentDomain + '/id/' + image.id + '?inapp=true'
      }
    }, [_c('v-lazy-image', {
      staticClass: "fullscreen-image",
      staticStyle: {
        "width": "100%",
        "min-height": "100%"
      },
      attrs: {
        "src": _vm.listviewImage(image.id, image)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "hidden-sm-and-down image-details-desktop"
    }, [_c('div', [_c('label', {
      staticClass: "image-caption"
    }, [_vm._v(_vm._s(image.caption))]), _vm._v(" "), _c('div', {
      staticClass: "image-location"
    }, [_c('label', {
      staticClass: "spot-name",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)) + " in\n                        ")]), _vm._v(" "), _c('label', {
      staticClass: "loc-name"
    }, [_vm._v(_vm._s(_vm.getCity(image)) + ",\n                          " + _vm._s(image.aboutLoc.country))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "details-btn p-3 pointer",
      attrs: {
        "href": _vm.currentDomain + '/id/' + image.id + '?inapp=true',
        "target": _vm.target
      }
    }, [_c('label', {
      staticClass: "pointer"
    }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
      staticClass: "footer-container-desktop"
    }, [_c('div', {
      staticClass: "photograher-likes-share"
    }, [_c('div', {
      staticClass: "photographer-container"
    }, [_c('div', {
      staticClass: "photographer",
      style: (image.uploader === 'admin' ?
        {
          color: '#b9b9b9'
        } :
        {
          cursor: 'pointer'
        }),
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ? _vm.saveInLs() : '';
          image.uploader !== 'admin' ?
            _vm.$router.push({
              path: '/profile',
              query: {
                uploader: image.uploader,
                profile_id: image.mediaSourceInformation
                  .photoGrapherId,
                selected_tab: 'checkins',
              },
            }) :
            '';
        }
      }
    }, [(image.uploader !== 'admin') ? _c('img', {
      attrs: {
        "src": image.mediaSourceInformation.photoGrapherPic,
        "alt": "profile-photo"
      },
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ?
            _vm.$router.push(
              ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
            ) :
            ''
        }
      }
    }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.cropUsername(
      image.mediaSourceInformation.photoGrapherName
    )) + "\n                            ©\n                          ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "likes",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "height": "fit-content"
      }
    }, [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "font-size": "1.403em",
        "margin-left": "5px"
      },
      style: ({
        color: ("" + (image.isLiked ? '#ff0000' : '#ffffff')),
        opacity: ("" + (image.isLiked ? '1' : '0.5')),
      }),
      on: {
        "click": function($event) {
          return _vm.changeCnt()
        }
      }
    }, [_vm._v(_vm._s(image.isLiked ?
      "favorite" :
      "favorite_outline"))])]), _vm._v(" "), _c('i', {
      staticClass: "\n                              white--text\n                              material-icons\n                              pointer\n                              flip-reply-icon\n                            ",
      on: {
        "click": function($event) {
          return _vm.share(
            image.id,
            image.caption === '' ? 'n' : image.caption
          )
        }
      }
    }, [_vm._v("reply")])])]), _vm._v(" "), _c('div', {
      staticClass: "location-and-travel-list"
    }, [_c('div', {
      staticClass: "want-scroll"
    }, [(image.propertyLink && _vm.tab === 'hotel') ? _c('a', {
      staticClass: "check-prices mr-1",
      attrs: {
        "href": image.propertyLink,
        "target": "_blank"
      }
    }, [_vm._v("\n                            Check Price\n                          ")]) : _vm._e(), _vm._v(" "), _c('button', {
      class: image.isCheckedin ?
        'on-travel-list' :
        'want-to-go-button-scroll',
      on: {
        "click": function($event) {
          return _vm.changeCntCheckin()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons mr-2",
      style: (!image.isCheckedin ?
        'color: white;font-size: 1.5rem;' :
        'font-size: 1.8em;color: #febd35')
    }, [_vm._v(_vm._s(image.isCheckedin ? "check" : "add"))]), _vm._v("\n                            " + _vm._s(image.isCheckedin ?
      "On travel list" :
      "Save to travel list") + "\n                          ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "container-over-image hidden-md-and-up"
    }, [_c('div', {
      staticClass: "likes",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "height": "fit-content"
      }
    }, [_c('span', {
      staticClass: "icon-container mr-3"
    }, [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "margin-top": "1px"
      },
      style: ({
        color: ("" + (image.isLiked ? '#ff0000' : '#ffffff')),
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeCnt()
        }
      }
    }, [_vm._v(_vm._s(image.isLiked ? "favorite" : "favorite_outline"))])])]), _vm._v(" "), _c('span', {
      staticClass: "icon-container"
    }, [_c('img', {
      attrs: {
        "src": "static/img/ic-reply.svg",
        "height": "24px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.share(
            image.id,
            image.caption === '' ? 'n' : image.caption
          )
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "icons-footer-2 hidden-md-and-up"
    }, [_c('div', {
      staticClass: "footer-container"
    }, [_c('div', {
      staticClass: "location-and-travel-list"
    }, [_c('div', {
      staticClass: "image-details-mobile"
    }, [_c('label', {
      staticClass: "image-caption",
      on: {
        "click": function($event) {
          return _vm.imageDet(image, imageIndex)
        }
      }
    }, [_vm._v(_vm._s(image.caption))]), _vm._v(" "), _c('div', {
      staticClass: "location-details",
      on: {
        "click": function($event) {
          return _vm.imageDet(image, imageIndex)
        }
      }
    }, [_c('label', {
      staticClass: "spot-name pointer",
      style: (_vm.getSpotType(image) == 'Spot' ?
        'opacity: 0.7' :
        'opacity : 1')
    }, [_vm._v(_vm._s(_vm.getSpotType(image)))]), _vm._v(" "), _c('label', {
      staticClass: "loc-name pointer"
    }, [_vm._v("in " + _vm._s(_vm.getCity(image)) + ",\n                            " + _vm._s(image.aboutLoc.country))])]), _vm._v(" "), _c('div', {
      staticClass: "photographer",
      style: (image.uploader === 'admin' ?
        {
          color: '#b9b9b9'
        } :
        {
          cursor: 'pointer'
        }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          image.uploader !== 'admin' ? _vm.saveInLs() : '';
          image.uploader !== 'admin' ?
            _vm.$router.push({
              path: '/profile',
              query: {
                uploader: image.uploader,
                profile_id: image.mediaSourceInformation
                  .photoGrapherId,
                selected_tab: 'checkins',
              },
            }) :
            '';
        }
      }
    }, [(
      image.mediaSourceInformation.photoGrapherPic !==
      'http://cdn.onlinewebfonts.com/svg/img_191958.png'
    ) ? _c('img', {
      attrs: {
        "src": image.mediaSourceInformation.photoGrapherPic,
        "alt": "profile-photo"
      },
      on: {
        "click": function($event) {
          image.uploader !== 'admin' ?
            _vm.$router.push(
              ("/profile?selected_tab=checkins&profile_id=" + (_vm.top_sectionArr[_vm.current_top_index].mediaSourceInformation.photoGrapherId))
            ) :
            ''
        }
      }
    }) : _vm._e(), _vm._v("\n                          " + _vm._s(_vm.cropUsername(
      image.mediaSourceInformation.photoGrapherName
    )) + "\n                          ©\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "want-scroll"
    }, [(image.propertyLink && _vm.tab === 'hotel') ? _c('a', {
      staticClass: "check-prices mr-1",
      attrs: {
        "href": image.propertyLink,
        "target": "_blank"
      }
    }, [_vm._v("\n                          Check Price\n                        ")]) : _vm._e(), _vm._v(" "), _c('button', {
      class: image.isCheckedin ?
        'on-travel-list' :
        'want-to-go-button-scroll',
      on: {
        "click": function($event) {
          return _vm.changeCntCheckin()
        }
      }
    }, [(!image.propertyLink) ? _c('i', {
      staticClass: "material-icons",
      style: (!image.isCheckedin ?
        'color: white;font-size: 1.8em;' :
        'font-size: 1.8em;color: #febd35')
    }, [_vm._v(_vm._s(image.isCheckedin ? "check" : "add"))]) : _vm._e(), _vm._v("\n                          " + _vm._s(image.isCheckedin ?
      "On travel list" :
      "Save to travel list") + "\n                        ")])])])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (
    _vm.filteredImagesArr.length == 0 &&
    this.selectedCity !== 'worldwide' &&
    this.selectedCity !== undefined
  ) ? _c('div', {
    staticClass: "no-photos"
  }, [_c('label', [_vm._v("No Photos Available for the current location filter.")])]) : _vm._e()])])])]), _vm._v(" "), _c('bottom-navigation', {
    attrs: {
      "localStorageName": "homePageImages",
      "screenH": _vm.screenH,
      "screenW": _vm.screenW,
      "view": "list",
      "maxPhotos": _vm.filteredImagesArr.length,
      "swipeIndex": _vm.swipeIndex,
      "isModeSwipe": this.$store.state.common.isModeSwipe,
      "lastSelectedQuery": this.$route.query.loc,
      "filteredImagesArr": _vm.filteredImagesArr,
      "isLoggedIn": this.$store.state.auth.isLoggedIn,
      "user": this.$store.state.auth.user,
      "setSwipeIndex": _vm.setSwipeIndex,
      "showModeNavigation": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "alt": "logo",
      "height": "30px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "text-decoration-none",
    attrs: {
      "href": "https://www.withaview.co"
    }
  }, [_c('img', {
    staticClass: "hidden-md-and-up mt-2",
    attrs: {
      "src": "/static/img/icons/wav-logo.png",
      "height": "24px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pill pointer",
    staticStyle: {
      "color": "#b6b6b6",
      "flex-grow": "1"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("note_add")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d17df2ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 848
// module chunks = 4